import { NumericOption } from "Components/Form/Select/selectTypes";
import { formatToLocaleString } from "Formatting/formatNumber";

const COVERAGE_AMOUNT_OPTIONS = [500000, 1500000, 2500000, 6000000];

export const getCoverageAmountOptions = (
  defaultLabel: string,
): NumericOption[] => [
  { value: undefined, label: defaultLabel },
  ...COVERAGE_AMOUNT_OPTIONS.map((amount) => ({
    value: amount,
    label: formatToLocaleString(amount),
  })),
];
